<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24.002"
    viewBox="0 0 24 24.002"
  >
    <g
      id="Group_5360"
      data-name="Group 5360"
      transform="translate(-853.945 -966.945)"
    >
      <rect
        id="Rectangle_1648"
        data-name="Rectangle 1648"
        width="24"
        height="24"
        transform="translate(853.945 966.945)"
        fill="none"
      />
      <g
        id="Path_1824"
        data-name="Path 1824"
        transform="translate(852.98 966.947)"
        fill="#ffd266"
      >
        <path
          d="M 12.96690845489502 21.76568031311035 C 12.30389785766602 20.55985641479492 11.3620662689209 18.98433494567871 10.3843412399292 17.7989501953125 C 7.229500770568848 13.97473049163818 6.108510971069336 12.24023056030273 5.723650932312012 11.45857048034668 C 5.243421077728271 10.48410129547119 5.000000953674316 9.455230712890625 5.000000953674316 8.400200843811035 C 5.000000953674316 4.31972074508667 8.588790893554688 1.000000953674316 13.00000095367432 1.000000953674316 C 17.41121101379395 1.000000953674316 21 4.31972074508667 21 8.400200843811035 C 21 9.455230712890625 20.7565803527832 10.48410129547119 20.27651023864746 11.4582405090332 C 19.55565071105957 12.92236137390137 17.21379089355469 15.73919105529785 15.50384140014648 17.79595184326172 C 14.48455810546875 19.02216339111328 13.58710670471191 20.57386589050293 12.96690845489502 21.76568031311035 Z"
          stroke="none"
        />
        <path
          d="M 13.00000095367432 2.000001907348633 C 9.140190124511719 2.000001907348633 6.000001907348633 4.871120452880859 6.000001907348633 8.400200843811035 C 6.000001907348633 9.300601005554199 6.208761215209961 10.18075084686279 6.620800018310547 11.01684093475342 C 6.982151031494141 11.75075054168701 8.062231063842773 13.41271114349365 11.15577125549316 17.16265106201172 C 11.79025554656982 17.93188667297363 12.40798664093018 18.85384750366211 12.94933128356934 19.74067687988281 C 13.46989345550537 18.86396789550781 14.07740211486816 17.94761657714844 14.73488140106201 17.15666198730469 C 16.31818008422852 15.25223064422607 18.71088027954102 12.37425136566162 19.37952041625977 11.01618099212646 C 19.79124069213867 10.18075084686279 20 9.300601005554199 20 8.400200843811035 C 20 4.871120452880859 16.85980987548828 2.000001907348633 13.00000095367432 2.000001907348633 M 13.00000095367432 1.9073486328125e-06 C 17.97026062011719 1.9073486328125e-06 22 3.761190414428711 22 8.400200843811035 C 22 9.651130676269531 21.69925117492676 10.83347129821777 21.17350006103516 11.90029048919678 C 20.41091156005859 13.4491605758667 18.11808013916016 16.21571159362793 16.27280044555664 18.43525123596191 C 14.45390129089355 20.62341117858887 13.00000095367432 24 13.00000095367432 24 C 13.00000095367432 24 11.33921051025391 20.52821159362793 9.612890243530273 18.43525123596191 C 7.614030838012695 16.01227188110352 5.543571472167969 13.35668087005615 4.826501846313477 11.90029048919678 C 4.300750732421875 10.83347129821777 4.000001907348633 9.651130676269531 4.000001907348633 8.400200843811035 C 4.000001907348633 3.761190414428711 8.029750823974609 1.9073486328125e-06 13.00000095367432 1.9073486328125e-06 Z"
          stroke="none"
          fill="#2d323c"
        />
      </g>
      <circle
        id="Ellipse_219"
        data-name="Ellipse 219"
        cx="3"
        cy="3"
        r="3"
        transform="translate(862.981 972.945)"
        fill="#fff"
        stroke="#2d323c"
        stroke-width="2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LocationColored',
}
</script>

<style lang="scss" scoped></style>
